import * as React from 'react'
import {Nullable} from '../../../../../app/TypeHelpers'
import {BlockSpacer, currentMedia, GridContainer, GridItem} from '../../../../../styledComponents/ResponsiveConvenience'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'
import {APPLY_CATEGORY, PET_TYPE} from '../../../../../CodeMaster'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {DisplayItemLabelDiv} from '../../../../../styledComponents/DisplayItem'
import {Box} from '@mui/material'
import styled from 'styled-components'
import {Colors, FontWeights} from '../../../../../styledComponents/Constants'
import {FileInformation} from '../../../../../components/applications/ResidentAttachmentFileArea'

interface Props {
    applicantFamilyName: Nullable<string>
    applicantFirstName: Nullable<string>
    petType: Nullable<string>
    petBreed: Nullable<string>
    healthCenterDogLicense: Nullable<FileInformation>
    rabiesPreventionInjectionCertification: Nullable<FileInformation>
    medicalCheckUpReport: FileInformation[]
    applyFlag?: boolean
}

const NatResidentPetMedicalCheckUpReportConfirm = ({applyFlag = true, ...otherProps}: Props) => {
    const {
        applicantFamilyName, applicantFirstName, petType, petBreed,
        healthCenterDogLicense, rabiesPreventionInjectionCertification, medicalCheckUpReport
    } = otherProps

    const applyCategoryLabel = APPLY_CATEGORY.MEDICAL_EXAMINATION_REPORT.label

    const petTypeLabel = (petType) ?
        PET_TYPE.codeToEnumConstants(petType).label : ''

    const petBreedLabel = petBreed ?? ''

    const applicantRoom = NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
        NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
        convertToRoomNumberForResident(
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
        )

    return (<>
        {applyFlag === true &&
            <>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請区分'}
                    items={[applyCategoryLabel]}
                />
                <BlockSpacer height={'5px'}/>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請者'}
                    items={[applicantRoom, `${applicantFamilyName} ${applicantFirstName}`]}
                />
                <BlockSpacer height={'5px'}/>
            </>
        }
        <NatResidentApplicationDetailConfirmItem
            title={'種類'}
            items={[petTypeLabel]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'品種'}
            items={[petBreedLabel]}
        />
        {(petType === PET_TYPE.DOG.value && healthCenterDogLicense) ?
            <>
                <BlockSpacer height={'5px'}/>
                <ItemDiv>
                    <GridContainer>
                        <GridItem over={3}><DisplayItemLabelDiv><Box mr={'5px'}>保健所犬鑑札</Box></DisplayItemLabelDiv>
                        </GridItem>
                        <GridItem over={9}>
                            <TextContents>
                                {healthCenterDogLicense.fileName}
                            </TextContents>
                        </GridItem>
                    </GridContainer>
                </ItemDiv>
            </> : null
        }

        {(petType === PET_TYPE.DOG.value && rabiesPreventionInjectionCertification) ?
            <>
                <BlockSpacer height={'5px'}/>
                <ItemDiv>
                    <GridContainer>
                        <GridItem over={3}><DisplayItemLabelDiv><Box mr={'5px'}>狂犬病予防注射済証</Box></DisplayItemLabelDiv>
                        </GridItem>
                        <GridItem over={9}>
                            <TextContents>
                                {rabiesPreventionInjectionCertification.fileName}
                            </TextContents>
                        </GridItem>
                    </GridContainer>
                </ItemDiv>
            </> : null
        }

        {(medicalCheckUpReport) ?
            <>
                <BlockSpacer height={'5px'}/>
                <ItemDiv>
                    <GridContainer>
                        <GridItem over={3}><DisplayItemLabelDiv><Box mr={'5px'}>健康診断書</Box></DisplayItemLabelDiv>
                        </GridItem>
                        <GridItem over={9}>
                            {(medicalCheckUpReport && medicalCheckUpReport.map((attachmentFile, index) => (
                                <TextContents key={index}>
                                    {attachmentFile.fileName}
                                </TextContents>
                            )))}
                        </GridItem>
                    </GridContainer>
                </ItemDiv>
            </> : null
        }
    </>)
}

NatResidentPetMedicalCheckUpReportConfirm.displayName = 'NatResidentPetMedicalCheckUpReportConfirm'
export default NatResidentPetMedicalCheckUpReportConfirm

const ItemDiv = styled.div`
  background-color: ${Colors.Surface};
 ${currentMedia.lessThan('sp')`
    margin: 0px -15px;
  `}
  padding: 20px 15px 20px 15px;
`
const TextContents = styled.div`
  font-weight: ${FontWeights.Bold};
  overflow-wrap: anywhere;
`